var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.004,
    height: 14.404,
    viewBox: "0 0 16.004 14.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-log-out-circle",
    transform: "translate(-4 -5.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30973",
    "data-name": "Path 30973",
    d: "M4,19.2l4,3.2V20h7.2V18.4H8V16Z",
    transform: "translate(0 -6.001)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30974",
    "data-name": "Path 30974",
    d: "M18.366,6a7.151,7.151,0,0,0-5.092,2.11l1.131,1.131a5.6,5.6,0,1,1,0,7.921l-1.131,1.131A7.2,7.2,0,1,0,18.366,6Z",
    transform: "translate(-5.564 0)",
    fill: "#777"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.80413cca7bef12c66f8c93895db5e909.svg";
export { ForwardRef as ReactComponent };